import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import { environment } from './environments/environment';
import { CustomStorage } from './app/storage.service';

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CustomStorage());

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId,
      loginWith: {
        email: true
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: environment.graphqlUrl,
      region: 'eu-central-1',
      defaultAuthMode: 'userPool'
    },
    REST: {
      callMeBackApi: {
        endpoint: environment.callMeBackApi
      },
      operatorDataApi: {
        endpoint: environment.host
      }
    }
  }
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
